import { render, staticRenderFns } from "./EchatsList2.vue?vue&type=template&id=3215ef3c&scoped=true&"
import script from "./EchatsList2.vue?vue&type=script&lang=js&"
export * from "./EchatsList2.vue?vue&type=script&lang=js&"
import style0 from "./EchatsList2.vue?vue&type=style&index=0&id=3215ef3c&lang=scss&scoped=true&"
import style1 from "./EchatsList2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3215ef3c",
  null
  
)

export default component.exports